import Page2 from "./page-2/page-2";
import Page4 from "./page-4/page-4";
import Page5 from "./page-5/page-5";
import Page6 from "./page-6/page-6";
import Page7 from "./page-7/page-7";
import Page8 from "./page-8/page-8";
import Page9 from "./page-9/page-9";
import Page10 from "./page-10/page-10";
import Page12 from "./page-12/page-12";
import Page13 from "./page-13/page-13";
import Page14 from "./page-14/page-14";
import Page15 from "./page-15/page-15";
import {Title} from "../../index";
import './forms.scss'

export default function Forms() {
    return (
        <ul className='vm-form'>
            <li id='page2'>
                <Title page='page2'/>
                <Page2/>
            </li> 
            <li id='page4'>
                <Title page='page4'/>
                <Page4/>
            </li>
            <li id='page5'>
                <Title page='page5'/>
                <Page5/>
            </li>
            <li id='page6'>
                <Title page='page6'/>
                <Page6/>
            </li>
            <li id='page7'>
                <Title page='page7'/>
                <Page7/>
            </li>
            <li id='page8'>
                <Title page='page8'/>
                <Page8/>
            </li>
            
            <li id='page12'>
                <Title page='page12'/>
                <Page12/>
            </li>
            <li id='page9'>
                <Title page='page9'/>
                <Page9/>
            </li>
            <li id='page10'>
                <Title page='page10'/>
                <Page10/>
            </li>
            <li id='page13'>
                <Title page='page13'/>
                <Page13/>
            </li>
            <li id='page14'>
                <Title page='page14'/>
                <Page14/>
            </li>
            <li id='page15'>
                <Title page='page15'/>
                <Page15/>
            </li>
        </ul>
    )
}
